@if(!(_userService.isLoggedIn$ | async)) {
  <ng-container>
    <div class="flex items-center justify-center h-[64px] w-[64px]">
      <button class="
          flex items-center justify-center
          rounded-full
          text-gray-600
          hover:text-gray-900
          transition
          w-10 h-10
        " (click)="toggleMenu()">
        <svg xmlns="http://www.w3.org/2000/svg" 
          fill="none" viewBox="0 0 24 24" 
          stroke-width="1.5" 
          stroke="currentColor" 
          class="shrink-0 w-9 h-9">
          <path stroke-linecap="round" stroke-linejoin="round" d="M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
        </svg>
      </button>
    </div>
  </ng-container>
}
@else 
{
  <ng-container>
    <div class="flex items-center px-3 h-[64px] w-[64px]">
      <button class="
          w-10 h-10
          flex items-center justify-center
          rounded-full
          text-gray-600
          hover:text-gray-900
          transition
          w-10 h-10
        " (click)="toggleMenu()">
        <svg xmlns="http://www.w3.org/2000/svg" 
          viewBox="0 0 24 24" 
          fill="currentColor"
          class="shrink-0 w-9 h-9">
          <path fill-rule="evenodd" d="M18.685 19.097A9.723 9.723 0 0 0 21.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12a9.723 9.723 0 0 0 3.065 7.097A9.716 9.716 0 0 0 12 21.75a9.716 9.716 0 0 0 6.685-2.653Zm-12.54-1.285A7.486 7.486 0 0 1 12 15a7.486 7.486 0 0 1 5.855 2.812A8.224 8.224 0 0 1 12 20.25a8.224 8.224 0 0 1-5.855-2.438ZM15.75 9a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z" clip-rule="evenodd" />
        </svg>

      </button>
    </div>
  </ng-container>
}

@if (isMenuOpen) {
  
  <div class="fixed inset-0 z-50">
    <!-- Background overlay -->
    <div 
      class="absolute inset-0 bg-black/10"
      (click)="isMenuOpen = false">
    </div>

    <!-- Menu panel -->
    <div class="
      absolute
      top-0 bottom-0 right-0
      w-[400px]
      border-l border-slate-300 bg-white
    ">
      <div class="flex flex-row items-center h-[64px] border-b border-slate-300">
        <div class="grow px-4">
          <h1>Account</h1>
        </div>
        <div class="flex items-center justify-center w-[64px] h-[64px]">
          <button class="
              flex items-center justify-center
              rounded-full
              text-gray-600
              hover:text-gray-800
              transition
              w-9 h-9
            " (click)="closeMenu()">
            <svg xmlns="http://www.w3.org/2000/svg" 
              fill="none" viewBox="0 0 24 24" 
              stroke-width="1.5" stroke="currentColor" class="shrink-0 w-8 h-8">
              <path stroke-linecap="round" stroke-linejoin="round" d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
            </svg>
          </button>
        </div>
      </div>
      <div class="p-4">

        <div class="mb-4">
          <app-login class="mb-3"></app-login>
        </div>

        @if(_userService.isLoggedIn$ | async) {
          <app-account></app-account>
        }
      </div>
    </div>

  </div>
}